import apiClient from '@/api/client'
import type { Notification, PaginatedResponse } from '@/types'

export interface NotificationPreferences {
  emailNotifications: boolean
  pushNotifications: boolean
  inAppNotifications: boolean
  leadAssigned: boolean
  dealWon: boolean
  dealLost: boolean
  taskDue: boolean
  taskOverdue: boolean
  mentions: boolean
  systemAlerts: boolean
}

export const notificationsApi = {
  getNotifications: (params?: {
    page?: number
    size?: number
    unreadOnly?: boolean
    type?: string
    /** Narrow to one workspace. Omitted means All Workspaces. */
    workspaceId?: string
  }) =>
    apiClient.get<PaginatedResponse<Notification>>('/notifications', { params }),

  getUnreadCount: (workspaceId?: string) =>
    apiClient.get<{ count: number }>('/notifications/unread-count', {
      params: workspaceId ? { workspaceId } : undefined,
    }),

  markAsRead: (id: string) =>
    apiClient.put<Notification>(`/notifications/${id}/read`),

  markAllRead: () =>
    apiClient.post('/notifications/read-all'),

  deleteNotification: (id: string) =>
    apiClient.delete(`/notifications/${id}`),

  getPreferences: () =>
    apiClient.get<NotificationPreferences>('/notifications/preferences'),

  updatePreferences: (data: Partial<NotificationPreferences>) =>
    apiClient.put<NotificationPreferences>('/notifications/preferences', data),
}
